import { ClosingControlState } from "../types/closing-control.type";
import { api } from "./apiClient";

// O fechamento é controlado POR ORÇAMENTO: todas as rotas recebem o budgetId.
export class ClosingControlService {
  static async get(
    projectId: string,
    budgetId: string,
  ): Promise<ClosingControlState> {
    return api
      .get(`/project/${projectId}/budget/${budgetId}/closing-control`)
      .then((response) => response.data);
  }

  static async sendToPreClosing(
    projectId: string,
    budgetId: string,
  ): Promise<ClosingControlState> {
    return api
      .post(
        `/project/${projectId}/budget/${budgetId}/closing-control/pre-closing`,
      )
      .then((response) => response.data);
  }

  static async returnClosing(
    projectId: string,
    budgetId: string,
  ): Promise<ClosingControlState> {
    return api
      .post(`/project/${projectId}/budget/${budgetId}/closing-control/return`)
      .then((response) => response.data);
  }
}
